// Build a calendar file (.ics) for a booking and hand it to the user through
// the same path every other file takes (fileExport): the native share sheet
// in the app, Web Share on phones, a download on desktop. Apple Calendar,
// Outlook and Google Calendar all open .ics files, and the same UID with a
// higher SEQUENCE updates an event that was added before, which is what a
// moved booking needs.
import { saveFile } from './fileExport';

const pad = (n) => String(n).padStart(2, '0');
const utcStamp = (d) => `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`;
const escapeText = (s) => String(s || '').replace(/([\\;,])/g, '\\$1').replace(/\r?\n/g, '\\n');
// RFC 5545: lines are at most 75 octets, continued with CRLF + a space.
const fold = (line) => {
    const out = [];
    let rest = line;
    while (rest.length > 74) { out.push(rest.slice(0, 74)); rest = ` ${rest.slice(74)}`; }
    out.push(rest);
    return out.join('\r\n');
};

export function buildIcs({ uid, start, end, title, description, location, url, sequence }) {
    const lines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Beu//Bookings//EN',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        `UID:${uid}`,
        `DTSTAMP:${utcStamp(new Date())}`,
        `SEQUENCE:${Number.isFinite(sequence) ? sequence : 0}`,
        `DTSTART:${utcStamp(start)}`,
        `DTEND:${utcStamp(end)}`,
        `SUMMARY:${escapeText(title)}`,
        description ? `DESCRIPTION:${escapeText(description)}` : null,
        location ? `LOCATION:${escapeText(location)}` : null,
        url ? `URL:${url}` : null,
        'BEGIN:VALARM',
        'TRIGGER:-PT1H',
        'ACTION:DISPLAY',
        `DESCRIPTION:${escapeText(title)}`,
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR',
    ].filter(Boolean).map(fold);
    return new Blob([lines.join('\r\n') + '\r\n'], { type: 'text/calendar;charset=utf-8' });
}

/** Save or share the booking as a calendar event. Returns fileExport's delivery mode. */
export async function addBookingToCalendar(event) {
    const blob = buildIcs(event);
    const filename = `${(event.filename || 'booking').replace(/[^a-z0-9-]+/gi, '-').toLowerCase()}.ics`;
    return saveFile({ blob, filename, title: event.title });
}
